module.exports = __webpack_public_path__ + "img/Frente-15-01 on.a2f3998a.png";